"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var ContractService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ContractService /> class.
     * @param http
     * @param config
     */
    function ContractService(http, config) {
        this.http = http;
        this.config = config;
    }
    ContractService.prototype.AddAssetOutcomeAsync = function (contractId, addAssetOutcomeRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/addAssetOutcome", addAssetOutcomeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Add a provisional contrat line
    * @param addProvisionalContractLineRequest
    * @returns An Observable containing the Phase
    */
    ContractService.prototype.AddProvisionalContractLineAsync = function (addProvisionalContractLineRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/" + addProvisionalContractLineRequest.contractId + "/addprovisional", addProvisionalContractLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Adjust roles.
     * @param deliverableId
     * @param adjustHeadRolesRequest
     * @returns An Observable containing boolean
     */
    ContractService.prototype.AdjustRolesAsync = function (deliverableId, adjustHeadRolesRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + deliverableId + "/adjustroles", adjustHeadRolesRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    ContractService.prototype.AdjustTermAsync = function (adjustDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/adjustterm", adjustDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Cancel Contrat Async.
   * @param contractId
   * @returns An Observable containing the boolean
   */
    ContractService.prototype.CancelContractAsync = function (contractId, comment) {
        var params = new http_1.HttpParams();
        params = params.set('comment', comment);
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/cancel", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Delete.
    * @param id
    * @returns An Observable containing boolean
    */
    ContractService.prototype.DeleteAsync = function (id) {
        return this.http.delete(this.config.DeliverablesApiURL + "/api/contracts/" + id)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Get.
     * @param id
     * @param allDescendants
     * @param immediateChildren
     * @returns An Observable containing the SimpleDContract
     */
    ContractService.prototype.GetAsync = function (id, allDescendants, immediateChildren) {
        var params = new http_1.HttpParams();
        if (allDescendants != null)
            params = params.set('allDescendants', allDescendants.toString());
        if (immediateChildren != null)
            params = params.set('immediateChildren', immediateChildren.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/contracts/" + id, { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List Async.
     * @param page
     * @param pageSize
     * @param feedId
     * @returns An Observable containing the model.IPagedList<DeliverableTopReadOnly>
     */
    ContractService.prototype.ListAsync = function (page, pageSize, feedId, ownerIds, workStatusTypes, contractTypeIds, fromDate, toDate, orderByCriteria, businessUnits, accountId) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (feedId)
            params = params.set('feedId', feedId.toString());
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (workStatusTypes)
            params = params.set('workStatusTypes', workStatusTypes);
        if (contractTypeIds)
            params = params.set('contractTypeIds', contractTypeIds);
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        if (businessUnits)
            params = params.set('businessUnits', businessUnits);
        if (accountId)
            params = params.set('accountId', accountId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/contracts/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
      * List PhasesAsync.
      * @param page
      * @param pageSize
      * @param feedId
      * @returns An Observable containing the IDeliverableAggregatePagedList<SimpleDPhaseWork>
      */
    ContractService.prototype.ListPhasesAsync = function (contractId, page, pageSize, ownerIds, workStatusTypes, productIds, fromDate, toDate, hasUnits, orderByCriteria, moduleIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (ownerIds)
            params = params.set('ownerIds', ownerIds);
        if (workStatusTypes)
            params = params.set('workStatusTypes', workStatusTypes);
        if (productIds)
            params = params.set('productIds', productIds);
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (hasUnits != null)
            params = params.set('hasUnits', hasUnits.toString());
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        return this.http.get(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/phases", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
       * List Async.
       * @param page
       * @param pageSize
       * @param feedId
       * @returns An Observable containing the model.IPagedList<DeliverableTopReadOnly>
       */
    ContractService.prototype.ListProjectsAsync = function (contractId, page, pageSize, workStatusTypes, productIds, fromDate, toDate, orderByCriteria, moduleIds, headModuleIds) {
        if (page === void 0) { page = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (workStatusTypes)
            params = params.set('workStatusTypes', workStatusTypes);
        if (productIds)
            params = params.set('productIds', productIds);
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (orderByCriteria)
            params = params.set('orderByCriteria', orderByCriteria);
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        if (headModuleIds)
            params = params.set('headModuleIds', headModuleIds);
        return this.http.get(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/projects", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * OnHold Contract Async.
   * @param contractId
   * @returns An Observable containing the boolean
   */
    ContractService.prototype.OnHoldContractAsync = function (contractId, comment, hold) {
        if (hold === void 0) { hold = true; }
        var params = new http_1.HttpParams();
        params = params.set('comment', comment);
        params = params.set('hold', hold.toString());
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/hold", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Fixed Contract via salesforce details
     * @param createContractRequest
     * @returns An Observable containing the DeliverableTopReadOnly
     */
    ContractService.prototype.CreateFullSOWSetupAsync = function (createFullSOWSetupRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/fromsalesforce", createFullSOWSetupRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Fixed Contract.
     * @param createContractRequest
     * @returns An Observable containing the DeliverableTopReadOnly
     */
    ContractService.prototype.CreateFixedAsync = function (createContractRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/", createContractRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Rolling Contract.
     * @param createRollingContractRequest
     * @returns An Observable containing the DeliverableTopReadOnly
     */
    ContractService.prototype.CreateRollingAsync = function (createRollingContractRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/rolling", createRollingContractRequest)
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Fixed Contract Line.
     * @param addFixedContractLineRequest
     * @returns An Observable containing the IProductLineProductHead
     */
    ContractService.prototype.CreateFixedContractLineAsync = function (addFixedContractLineRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/AddFixedLine", addFixedContractLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Create Rolling Contract Line.
     * @param addRollingContractLineRequest
     * @returns An Observable containing the IProductLineProductHead
     */
    ContractService.prototype.CreateRollingContractLineAsync = function (addRollingContractLineRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/contracts/AddRollingLine", addRollingContractLineRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
  * Lock A Contract Term Async.
  * @param lockDeliverableTermRequest
  * @returns An Observable containing a boolean
  */
    ContractService.prototype.LockAsync = function (contractId, lockDeliverableTermRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/lock", lockDeliverableTermRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Set Contractual End Date
   * @param contractId
   * @returns An Observable containing the boolean
   */
    ContractService.prototype.SetContractualEndDateAsync = function (setContractualEndDateRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + setContractualEndDateRequest.contractId + "/setcontractualenddate", setContractualEndDateRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Switch Product Async.
     * @param contractId
     * @returns An Observable containing the boolean
     */
    ContractService.prototype.SwitchContractTypeAsync = function (switchContractTypeRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + switchContractTypeRequest.contractId + "/switchtype", switchContractTypeRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Terminate Rolling Contract
     * @param terminateRollingContractRequest
     * @returns An Observable containing the DeliverableBase
     */
    ContractService.prototype.TerminateRollingContractAsync = function (terminateRollingContractRequest) {
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + terminateRollingContractRequest.contractId + "/terminate", terminateRollingContractRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * TrimUnassignedUnits Async.
   * @param deliverableId
   * @param feedback
   * @returns An Observable containing the boolean
   */
    ContractService.prototype.TrimUnAssignedUnitsAsync = function (contractId, feedback) {
        var params = new http_1.HttpParams();
        if (feedback)
            params = params.set('feedback', feedback);
        return this.http.put(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/trimunassigned", null, { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List total aggregate units in months sub group by Department, Work Ready Status, Contract Type or Feed
     * @param contractId   *
     * @param fromDate
     * @param toDate
     * @param subGroup
     * @param unitType
     * @returns An Observable containing the Array<MonthlyUnitsAggregate>
     */
    ContractService.prototype.UnitsScopeInMonthsAsync = function (contractId, fromDate, toDate, subGroup, unitType) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (subGroup && subGroup.id)
            params = params.set('subGroup', subGroup.id.toString());
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/contracts/" + contractId + "/unitsscopeinmonths", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ContractService.ngInjectableDef = i0.defineInjectable({ factory: function ContractService_Factory() { return new ContractService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ContractService, providedIn: "root" });
    ContractService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ContractService);
ContractService.ɵfac = function ContractService_Factory(t) { return new (t || ContractService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ContractService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ContractService, factory: function (t) { return ContractService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContractService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ContractService;
}());
exports.ContractService = ContractService;

